import { SHA256 } from 'crypto-js';
import { generateUniqEventId } from 'src/shared/utils/generateUniqEventId';

declare global {
  interface Window {
    fbq: any;
  }
}

export class FacebookPixelService {
  id = 'facebook';

  isDebugOnly = false;

  private facebookPixelId: string;

  constructor(facebookPixelId: string, isDebugOnly: boolean) {
    this.facebookPixelId = facebookPixelId;
    this.isDebugOnly = isDebugOnly;
  }

  public async initialize() {
    try {
      if (!this.facebookPixelId) {
        console.error('[FacebookPixelService]: Facebook Pixel ID is missing');
        return;
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${this.facebookPixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);

      console.log('[FacebookPixelService]: Initialized 🚀');
    } catch (e) {
      console.error(`[FacebookPixelService]: Initialization failed:`, e);
    }
  }

  public sendEvent(eventName: string, properties?: Record<string, any>, isCustomEvent: boolean = false) {
    try {
      if (!window?.fbq) {
        console.error('[FacebookPixelService]: Facebook Pixel not initialized');
        return;
      }

      // Extract tracking parameters
      const { eventInstanceId, userId, email, firstName, lastName, ...restProperties } = properties ?? {};

      // Generate unique event ID if we have the required data
      let uniqEventId = null;
      if (userId && eventInstanceId) {
        uniqEventId = generateUniqEventId(eventName, userId, eventInstanceId);
      }

      const customEvents = ['AppOpened'];
      const propertiesToSend = {
        ...restProperties,
        ...(email && { em: SHA256(email).toString() }),
        ...(firstName && { fn: SHA256(firstName).toString() }),
        ...(lastName && { ln: SHA256(lastName).toString() }),
        ...(userId && { external_id: userId }),
      };

      console.log('[FacebookPixelService] propertiesToSend', propertiesToSend);

      if (customEvents.includes(eventName)) {
        window.fbq('trackCustom', eventName, propertiesToSend, uniqEventId ? { eventID: uniqEventId } : {});
      } else {
        window.fbq('track', eventName, propertiesToSend, uniqEventId ? { eventID: uniqEventId } : {});
      }

      console.log(`[FacebookPixelService]: Track event: ${eventName} completed`);
    } catch (e) {
      console.error(`[FacebookPixelService]: Send event failed:`, e);
    }
  }
}
